
    <div class="ui-g-12">
      <button *ngIf="showBack" pButton type="button" class="k-generic-btn" icon="fa fa-chevron-left"
              iconPos="left" label="{{ 'common.back' | translate }}"
              (click)="_onBack()"
      ></button>
      <form [formGroup]="searchForm" (submit)="onSearch()">
        <div class="k-row ui-g-12">
          <div [kv-form-element]="{ label: 'common.surname', md: '4'}">
            <input pInputText formControlName="surname" />
          </div>
          <div [kv-form-element]="{ label: 'common.name', md: '4'}">
            <input pInputText formControlName="name" />
          </div>
          <div [kv-form-element]="{ label: 'customers.card_no', md: '4'}">
            <input pInputText formControlName="card_no" />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4"></div>
          <div class="ui-g-4">
            <button pButton type="submit" class="buttonExpand k-generic-btn" icon="fa fa-search" iconPos="left" [label]="'common.apply' | translate" ></button>
          </div>
          <div class="ui-g-4"></div>
        </div>
      </form>
      <div class="ui-g-12" *ngIf="searchPress">

        <app-kontable #tablePT *ngIf="customerItems && searchPress"
                      title = "{{ 'customers.customers_card_search' | translate }}"
                      [columns] = "[
                           'card_no',
                           'divisionSalesNetwork',
                           'channelCode',
                           'storeDescription',
                           'customerDescription',
                           'birth_date',
                           'flg_blk_lst',
                           'customerState'
                        ]"
                      [titles] = "[
                          'customers.card_no',
                           'loyalty.divisionSalesNetwork',
                           'loyalty.channelCode',
                           'loyalty.storeDescription',
                           'loyalty.customerDescription',
                           'common.name',
                           'common.birth_date',
                           'loyalty.blacklist',
                           'common.status'
                        ]"
                      [showDetailsButton]="false"
                      [showInfoButton]="false"
                      [showEditButton]="false"
                      [showGlobalFilter]="false"
                      [showDeleteButton]="false"
                      [showRecoverButton]="false"
                      [source]="customerItems"
                      [paginationType]="paginationType"
                      [additionalRowCommands]="customActions">
          <ng-template #customActions let-row>

            <p-button pTooltip="{{ 'common.select' | translate }}" icon="fa fas fa-arrow-circle-right"  styleClass="ui-button-info" (onClick)="_onCardSelect(row)"></p-button>
          </ng-template>
        </app-kontable>

      </div>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/views/customerDB/widget/customer-card-search/customer-card-search.component.ts.CustomerCardSearchComponent.html